<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'+'场地'"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :visible.sync="visible"
    width="720px"
    height="456px"
    class="info-dialog"
  >
    <el-form
      ref="dataForm"
      label-position="right"
      label-width="120px"
      :model="dataForm"
      :rules="rules"
    >
      <el-form-item prop="filedName" label="场地名称：">
        <el-input
          v-model.trim="dataForm.filedName"
          placeholder="请输入场地名称"
          maxlength="30"
          clearable
        />
      </el-form-item>
      <el-form-item prop="fieldCode" label="场地编码：">
        <el-input
          v-model.trim="dataForm.fieldCode"
          placeholder="请输入场地编码"
          maxlength="30"
          clearable
        />
      </el-form-item>
      <el-form-item prop="fieldType" label="场地类型：">
        <el-select v-model="dataForm.fieldType" clearable placeholder="请输入场地类型">
          <el-option label="开标室" value="2"/>
          <el-option label="评标室" value="3"/>
          <el-option label="专家抽取室" value="1"/>
        </el-select>
      </el-form-item>
      <el-form-item prop="seatNum" label="机位数：">
        <el-input
          v-model.number="dataForm.seatNum"
          placeholder="请输入机位数"
          maxlength="9"
          oninput="value=value.replace(/[^0-9]/g,'')"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-preventReClick type="primary" @click="dataFormSubmit()">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: '',
        tradeOrgId: '',
        filedName: '',
        fieldCode: '',
        fieldType: '',
        seatNum: '',
        parentId: ''
      },
      rules: {
        filedName: [
          { required: true, message: '请填写场地名称', trigger: 'blur' }
        ],
        fieldCode: [
          { required: true, message: '请填写场地编码', trigger: 'blur' }
        ],
        fieldType: [
          { required: true, message: '请选择场地类型', trigger: 'blur' }
        ],
        seatNum: [
          { required: true, message: '请填写机位数', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      this.visible = false
    },
    init(id, tradeOrgId) {
      this.visible = true
      this.dataForm.id = id || ''
      this.dataForm.tradeOrgId = tradeOrgId
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http.get(`/configs/sysevalroom/get?id=${id}`).then(res => {
            if (res.data.code === '1') {
              this.dataForm = res.data.data ? res.data.data : {}
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http.post(`/configs/sysevalroom/save`,this.dataForm).then(res => {
            if (res.data.code === '1') {
              this.$message.success(res.data.msg)
              this.visible = false
              this.dataForm
              this.$emit('refreshDataList')
            } else {
              this.$message.error(res.data.msg)
              this.visible = false
            }
          })
        }
      })
    }
  }
}
</script>
